export type DamageReason = 'STAFF_DAMAGE' | 'SUPPLIER_DAMAGE';

export const DAMAGE_REASON_OPTIONS: { value: DamageReason; label: string }[] = [
  { value: 'SUPPLIER_DAMAGE', label: 'Supplier Damage' },
  { value: 'STAFF_DAMAGE', label: 'Staff Damage' },
];

export const DAMAGE_REASON_LABEL: Record<DamageReason, string> = {
  SUPPLIER_DAMAGE: 'Supplier Damage',
  STAFF_DAMAGE: 'Staff Damage',
};
